// extracted by mini-css-extract-plugin
export default {"container":"EAFSGAreas_container__q8ZTc"};